import ApiActions from '../actions/api';
import { getLocalService } from '../components/triggers/get-local-service';
import { noop } from '../props/empty';
import {
  setHandoffToken,
  getDeepLinkIfPresent,
} from '../services/signup-service';
import { requestHandoffToken } from '../services/handoff-service';

export function callTriggerAction(
  entity,
  method,
  data,
  serviceVersion,
  callback = noop
) {
  if (serviceVersion === 'local') {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      let service = getLocalService(entity);
      // we use import with '*' for EventService because an es6 conflict and here we have to access 'default' property
      // if better solution will be found this need to change
      if (
        service &&
        !service[method] &&
        service['default'] &&
        service['default'][method]
      ) {
        service = service['default'];
      }
      await service[method].call(service, data);
      resolve();
    }).then(() => {
      callback();
    });
  }

  return ApiActions.post(
    { entity, method, data, callback: false, serviceVersion },
    true
  )
    .then(async response => {
      if (
        entity === 'User' &&
        method === 'create' &&
        response &&
        response.result
      ) {
        // Mint the handoff token immediately after account creation, while the user
        // session (sl-user-data) is still in localStorage. The completion logout at
        // the last onboarding step clears localStorage before triggersFinishedFiring()
        // can call requestHandoffToken(), so we pre-mint it here and store it in
        // sessionStorage (which the completion logout does not clear).
        // IMPORTANT: must be awaited before calling callback() — the callback triggers
        // a page navigation to the questionnaire, which would kill the in-flight promise.
        if (getDeepLinkIfPresent()) {
          const token = await requestHandoffToken();
          if (token) {
            setHandoffToken(token);
          }
        }
      }
      if (
        response &&
        (response.redirect_url ||
          (response.result && response.result.redirect_url))
      ) {
        callback(response.redirect_url || response.result.redirect_url);
      } else {
        callback();
      }
    })
    .catch(error => {
      console.log(error);
      callback(null, true);
    });
}
